<template>
	<div id="navBar">
		 <!-- <div class='unqualified' v-if='preventMessage'>
		  		<span>{{preventMessage}}</span>
		  </div> -->
		<div class="navBar_container">
			<el-tabs
				type="card"
				closable
				v-model="activeName"
				@tab-click="tabClick"
				@tab-remove="closeSelectedTag"
				@contextmenu.prevent.native="openMenu">
				<el-tab-pane
					v-for="(item,index) in Array.from(defaultVisitedViews)"
					:label="item.meta.label"
					:name="item.name" :key='item.name'>
				</el-tab-pane>
			</el-tabs>
			<ul v-show="visible" :style="visibleType" class="contextmenu" ref="contextmenu">
				<li @click="refreshSelectedTag">刷新</li>
				<li @click="closeSelectedTag(selectedTag)">关闭</li>
				<li @click="closeOthersTags">关闭其他</li>
				<li @click="closeAllTags">关闭所有</li>
			</ul>
		</div>

	</div>
</template>

<script>
export default {
	data () {
		return {
			visibleType: {
				top: 0,
				left: 0
			},
			defaultVisitedViews: [],
			selectedTag: {},
			viewsPath: [],
			activeName: 'home',
			visible: false,		// 是否显示右键菜单
		}
	},
	computed: {
		visitedViews () {
			return this.$store.state.tagsView.visitedViews
		},
		navStyle () {
			return `translateX(-${this.navOffset}px)`;
		},
		// preventMessage() {
		// 	let superPreventOperation = this.$store.getters.superPreventOperation;
		// 	if(this.$getSessionStorage('superPreventOperation') || superPreventOperation) {
		// 		return superPreventOperation || this.$getSessionStorage('superPreventOperation').replace(/\"/g, "");
		// 	}else {
		// 		return false;
		// 	}
		// }
	},
	methods: {
		// 根据当前路由添加class
		isActive (route) {
			return route.path === this.$route.path ? 'active' : '';
		},
		// 获取当前路由
		generateRoute () {
			this.activeName = this.$route.name;
			return this.$route.name ? this.$route : false;
		},
		// 添加标签
		addViewTags() {
			const route = this.generateRoute();
			if(route.fullPath == '/error') {
				return;
			}
			if(!route) return false;
			this.$store.dispatch('addView', route);
			this.setViewsTags(this.visitedViews, 'add');
		},
		// 设置标签
		setViewsTags(res, status) {

			if (res[0].meta.title == 'home') {
				this.defaultVisitedViews = res;
			} else {
				if (status == 'add') {
					res.forEach(item => {
						if (this.defaultVisitedViews.indexOf(item) == -1) {
							this.defaultVisitedViews.push(item);
						}
					})
				} else {
					this.defaultVisitedViews = res;
				}
			}
		},
		// 刷新/重载
		refreshSelectedTag () {
			let NewPage = '_empty' + '?time=' + new Date().getTime()/500;
      this.$router.push(NewPage);
      this.$router.go(-1);
		},
		// 切换
		tabClick (tab) {
			this.$store.commit('ISCLICKCACHE',false);
			if (tab.name === this.$route.name) return;
			for (const i of this.visitedViews) {
				if (i.name === tab.name) {
					this.selectedTag = i;
					break;
				}
			}

			if (tab.name === '首页') {
				this.$router.push('/home');
				this.addViewTags();
			} else {
				this.$router.push(this.selectedTag)
			}
		},
		// 关闭
		closeSelectedTag (view) {
			let tag;
			let bol = this.$store.state.loadstatus.ifEditVoucer;
			let menu = this.$getSessionStorage('menu');
			let _ = this;
			if(view === 'home' || view.name === 'home') return this.$message.error({
				showClose: true,
				message: '首页不可关闭！'
			});
			if(view == '新增凭证' && this.$route.fullPath == '/addVoucher') {
				console.log(view)
				console.log(this.$route.fullPath)
				if(bol){
					this.$confirm('检测到新增凭证已更改，是否关闭？','提示',{
						confirmButtonText:'确认关闭',
						cancelButtonText:'再想想',
						closeOnClickModal:false,
						showClose: false,
					}).then(()=>{
						if (typeof view === 'string') {
							tag = this.visitedViews.find(item => { return item.name === view });
						} else {
							tag = view;
						};

						this.$store.dispatch('delView', tag).then(({ visitedViews }) => {
							if (this.isActive(tag)) {
								const latestView = visitedViews.slice(-1)[0];
								if(latestView) {
									this.$router.push(latestView)
									this.delVisitedView(view)
								} else {
									this.defaultVisitedViews=[];
									if(!menu[0].children.length) {
										this.$router.push({ path:`${menu[0].href}` });
									}else {
										this.$router.push({ path:`${menu[0].children[0].href}` });
									}
									 this.refreshSelectedTag();
									//this.addViewTags()
								}
							} else {
								this.delVisitedView(view)
							}
						})
						_.$store.commit('UPDATAVOUCHER',false);
						_.$store.commit('UPDATAVOUCHER_SUPER',true);
					}).catch(()=>{
						_.$store.commit('UPDATAVOUCHER_SUPER',false);
						_.$store.commit('UPDATAVOUCHER',true);
					});
				}else{
					if (typeof view === 'string') {
						tag = this.visitedViews.find(item => { return item.name === view });
					} else {
						tag = view;
					};

					this.$store.dispatch('delView', tag).then(({ visitedViews }) => {
						if (this.isActive(tag)) {
							const latestView = visitedViews.slice(-1)[0];
							if(latestView) {
								this.$router.push(latestView)
								this.delVisitedView(view)
							} else {
								this.defaultVisitedViews=[];
								if(!menu[0].children.length) {
									this.$router.push({ path:`${menu[0].href}` });
								}else {
									this.$router.push({ path:`${menu[0].children[0].href}` });
								}
								//this.addViewTags()
								this.refreshSelectedTag();
							}
						} else {
							this.delVisitedView(view)
						}
					})
				};
				_.$store.commit('UPDATAVOUCHER',false);
				_.$store.commit('UPDATAVOUCHER_SUPER',true);
			}else {
				if (typeof view === 'string') {
					tag = this.visitedViews.find(item => { return item.name === view });
				} else {
					tag = view;
				};

				this.$store.dispatch('delView', tag).then(({ visitedViews }) => {
					if (this.isActive(tag)) {
						const latestView = visitedViews.slice(-1)[0];
						if(latestView) {
							this.$router.push(latestView)
							this.delVisitedView(view)
						} else {
							this.defaultVisitedViews=[];
							if(!menu[0].children.length) {
								this.$router.push(menu[0].href);
							}else {
								this.$router.push(menu[0].children[0].href);
							}
							//this.addViewTags()
							// this.refreshSelectedTag();
						}
					} else {
						this.delVisitedView(view)
					}
				})

				if(view==="新增凭证") {
					_.$store.commit('UPDATAVOUCHER_SUPER',true);
				}
			}

		},
		// 关闭其他
		closeOthersTags () {
			let _ = this;
			let bol = this.$store.state.loadstatus.ifEditVoucer;
			if(this.selectedTag.path == '/addVoucher' && this.selectedTag.fullPath == '/addVoucher') {
				this.$router.push(this.selectedTag);
				this.$store.dispatch('delOthersViews', this.viewsPath);
				this.setViewsTags(this.viewsPath, 'closeOthersTags');
			}else {
				if(bol) {
					this.$confirm('检测到新增凭证已更改，是否关闭其他？','提示',{
						confirmButtonText:'确认关闭',
						cancelButtonText:'再想想',
						showClose: false,
						closeOnClickModal:false,
					}).then(()=>{
						this.$router.push(this.selectedTag);
						this.$store.dispatch('delOthersViews', this.viewsPath);
						this.setViewsTags(this.viewsPath, 'closeOthersTags');
						_.$store.commit('UPDATAVOUCHER',false);
						_.$store.commit('UPDATAVOUCHER_SUPER',true);
					}).catch(()=>{
						_.$store.commit('UPDATAVOUCHER',true);
					})
				}else {
					this.$router.push(this.selectedTag);
					this.$store.dispatch('delOthersViews', this.viewsPath);
					this.setViewsTags(this.viewsPath, 'closeOthersTags');
					_.$store.commit('UPDATAVOUCHER_SUPER',true);
				}
			}
		},
		// 关闭所有
		closeAllTags () {
			let _ = this;
			// if(_.defaultVisitedViews.length===1) {
			// 	return _.$message({
			// 		message:"系统会至少保留一个标签！",
			// 		type:'warning'
			// 	})
			// }
			let bol = this.$store.state.loadstatus.ifEditVoucer;
			if(bol) {
				this.$confirm('检测到新增凭证已更改，是否全部关闭？','提示',{
					confirmButtonText:'确认关闭',
					cancelButtonText:'再想想',
					showClose: false,
					closeOnClickModal:false,
				}).then(()=>{
				let menu = this.$getSessionStorage('menu');
				this.$store.dispatch('delAllViews');
				if(menu[0].href=='/home') {
						this.$router.push('/');
						this.addViewTags();
					}else {
						this.$router.push(`${menu[0].children[0].href}`);
						this.addViewTags();
						this.refreshSelectedTag();
					}
					_.$store.commit('UPDATAVOUCHER',false);
					_.$store.commit('UPDATAVOUCHER_SUPER',true);
				}).catch(()=>{
					_.$store.commit('UPDATAVOUCHER',true);
				})
			}else {
				let menu = this.$getSessionStorage('menu');
				this.$store.dispatch('delAllViews');
				if(menu[0].href=='/home') {
					this.$router.push('/');
					this.defaultVisitedViews= [{
							fullPath: '/index',
							path: '/index',
							meta: {
								label: '首页',
								title: 'home'
							},
							name: 'home',
						}
					]
				}else {
					this.$router.push(`${menu[0].children[0].href}`);
					this.addViewTags();
					this.refreshSelectedTag();
				}
				_.$store.commit('UPDATAVOUCHER_SUPER',true);

			}

		},
		// 打开右键菜单
		openMenu (e) {
			const offsetLeft = this.$el.getBoundingClientRect().left;
			const width = this.$el.getBoundingClientRect().width;
			let menuWidth, left, top;

			if (e.target.id) {
				this.visible = true;
				this.viewsPath = this.defaultVisitedViews.filter(item => {
					return item.meta.title === 'home' || item.meta.label === e.target.innerText;
				})
				for (const i of this.visitedViews) {
					if (i.meta.label === e.target.innerText) {
						this.selectedTag = i;
						break;
					}
				}
				this.$nextTick(() => {
					menuWidth = this.$refs.contextmenu.clientWidth;
					left = e.clientX - offsetLeft;
					top = e.clientY;

					this.visibleType = Object.assign({}, this.visibleType, {
						left : menuWidth + left < width ? `${left}px` : width - menuWidth - 15 - 140 + 'px',
						top : e.clientY - 30 + 'px'
					})
				})
			}
		},
		// 删除默认
		delVisitedView (view) {
			for (const [i, v] of this.defaultVisitedViews.entries()) {
				if (v.name === view || v.name === view.name) {
					this.defaultVisitedViews.splice(i, 1);
					break;
				}
			}
		},
		// 关闭右键菜单
		closeMenu () {
			this.visible = false;
		}
	},
	mounted () {
		 this.addViewTags();
	},
	created(){
		if(this.$getSessionStorage('menu')[0].href==="/home"){
			this.defaultVisitedViews.push({
				fullPath: '/home',
				path: '/home',
				meta: {
					label: '首页',
					title: 'home'
				},
				name: '首页',
			})
		}else {
			this.defaultVisitedViews = [];
		}
	},
	watch: {
		$route () {
			this.addViewTags();
		},
		visible (value) {
			value ? document.body.addEventListener('click', this.closeMenu) : document.body.removeEventListener('click', this.closeMenu)
		}
	}
}
</script>

<style lang="less" >
	#navBar{
		position: fixed;
		top:60px;left: 140px;
		height: 32px;
		width:100%;

		background-color:#eee;
		z-index:1900;
		// .unqualified{
		// 	width: 100%;
		// 	height:44px;
		// 	background: #FFEAEA;
		// 	line-height: 44px;
		// 	color: #D0021B;
		// 	font-size: 14px;
		// 	font-weight: bold;
		// 	text-align: center;
		// 	opacity: .6;
		// }
		.navBar_container {
			padding: 15px 180px 15px 20px;
		}
		.el-tabs__header{
			margin: 0;
			padding: 0;
			border: 0;
			.el-tabs__nav {
				border: 0;
        background: #eee;
			}
		}
		.el-tabs__nav-wrap {
			margin-bottom: 0;
		}
		.el-tabs__nav-next, .el-tabs__nav-prev {
			line-height: 32px;
		}
		.el-tabs__item {
			height: 32px;
			line-height: 32px;
			margin-right: 15px;
			padding-left: 19px;
			padding-right: 19px;
			color: #999;
			background-color: #fff;
			// box-shadow: 0px 0px 18px 0px rgba(223,223,223,1);
			border-radius: 5px;
      border:none;
			&.is-active {
        font-weight: 600;
				color: #269D7B;
        background-color: rgba(38, 157, 123, 0.1);
        .el-icon-close {
          &:hover {
            background-color: #269D7B;
          }
        }
			}
			&:last-child {
				margin-right: 0;
			}
		}
		#tab-首页 {
			.el-icon-close {
				display: none;
			}
		}
		.contextmenu {
			margin: 0;
			padding: 5px 0;
			font-size: 12px;
			font-weight: 400;
			color: #666;
			background-color: #fff;
			position: absolute;
			list-style-type: none;
			border-radius: 4px;
			box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
			z-index: 1900;
			li {
				margin: 0;
				min-width: 80px;
				padding: 7px 10px;
				cursor: pointer;
				&:hover {
					background-color: #999;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/main/NavBar.vue